import { Injectable } from '@angular/core';

import { AnalyticsBase } from '../analytics-base';

@Injectable()
export class ProfileAnalytics extends AnalyticsBase {
  public readonly namespace = 'Profile';
  public readonly requireViewContext = true;

  public trackEmailActivation(provider: string) {
    this.track('ActivateEmail', { provider });
  }

  public trackCalendarSync(provider: string) {
    this.track('SyncCalendar', { provider });
  }

  public trackCalendarSyncClick(provider: string) {
    this.track('SyncCalendarClick', { provider });
  }

  public trackSetOutOfOffice(props: {
    oooEnabled: boolean;
    oooStartsAt: string | null;
    oooEndsAt: string | null;
    oooIncludeSignature: boolean;
  }) {
    this.track('SetOutOfOffice', props);
  }
}
